import { SvgIcon } from '@mui/material';

export const OrganizationIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill="currentColor"
      d="M11 12v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-1a1 1 0 0 0-2 0m10.664-1.748l-9-8a1 1 0 0 0-1.328 0l-9 8a1 1 0 0 0 1.328 1.496L4 11.449V21a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9.551l.336.299a1 1 0 0 0 1.328-1.496M18 20H6V9.671l6-5.333l6 5.333Z"
    />
  </SvgIcon>
);

export const PatientOutlined = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M20 22V19C20 16.172 20 14.757 19.121 13.879C18.243 13 16.828 13 14 13H10C7.172 13 5.757 13 4.879 13.879C4 14.757 4 16.172 4 19C4 19.932 4 20.398 4.152 20.765C4.252 21.008 4.4 21.228 4.586 21.414C4.772 21.6 4.992 21.747 5.235 21.848C5.602 22 6.068 22 7 22V13.5M9.5 13L12.5 22"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M12 19H14.5C14.898 19 15.279 19.158 15.561 19.439C15.842 19.721 16 20.102 16 20.5C16 20.898 15.842 21.279 15.561 21.561C15.279 21.842 14.898 22 14.5 22H12.5M15.5 6.5V5.5C15.5 4.57174 15.1313 3.6815 14.4749 3.02513C13.8185 2.36875 12.9283 2 12 2C11.0717 2 10.1815 2.36875 9.52513 3.02513C8.86875 3.6815 8.5 4.57174 8.5 5.5V6.5C8.5 7.42826 8.86875 8.3185 9.52513 8.97487C10.1815 9.63125 11.0717 10 12 10C12.9283 10 13.8185 9.63125 14.4749 8.97487C15.1313 8.3185 15.5 7.42826 15.5 6.5Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </SvgIcon>
);

export const ErrorOutline = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill="currentColor"
      d="M12.713 16.713Q13 16.425 13 16t-.288-.712T12 15t-.712.288T11 16t.288.713T12 17t.713-.288M11 13h2V7h-2zm1 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"
    />
  </SvgIcon>
);

export const DoctorOutlined = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h20v20H0z" fill="none" />
    <path
      fill="currentColor"
      d="M2.75 2a.75.75 0 0 0-.75.75v5c0 2.23 1.622 4.08 3.75 4.438v1.062a5.25 5.25 0 1 0 10.5 0v-1.104a2.751 2.751 0 1 0-1.5 0v1.104a3.75 3.75 0 1 1-7.5 0v-1.062A4.5 4.5 0 0 0 11 7.75v-5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5h.75v4.25a3 3 0 1 1-6 0V3.5h.75a.75.75 0 0 0 0-1.5zM15.5 8.25a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5"
    />
  </SvgIcon>
);

export const ProviderOutlined = props => (
  <SvgIcon {...props} viewBox="0 0 18 22">
    <path
      d="M0.875 20.875V19.875C0.875 18.006 0.875 17.071 1.277 16.375C1.54029 15.919 1.91898 15.5403 2.375 15.277C3.071 14.875 4.005 14.875 5.875 14.875L8.875 18.875L11.875 14.875C13.745 14.875 14.679 14.875 15.375 15.277C15.831 15.5403 16.2097 15.919 16.473 16.375C16.875 17.071 16.875 18.006 16.875 19.875V20.875M12.812 6.875L13.83 2.739C14.063 1.792 13.358 0.875 12.398 0.875H5.352C4.392 0.875 3.687 1.792 3.92 2.739L4.938 6.875M12.812 6.875V8.875C12.812 11.084 11.05 12.875 8.875 12.875C6.7 12.875 4.938 11.084 4.938 8.875V6.875M12.812 6.875H4.938M8.875 2.875V4.875M9.875 3.875H7.875"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const HomeIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill="currentColor"
      d="m12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81zM12 3L2 12h3v8h6v-6h2v6h6v-8h3z"
    />
  </SvgIcon>
);

export const PersonIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
  <path fill="currentColor" d="M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5s-5 2.24-5 5s2.24 5 5 5m0-8c1.65 0 3 1.35 3 3s-1.35 3-3 3s-3-1.35-3-3s1.35-3 3-3M4 22h16c.55 0 1-.45 1-1v-1c0-3.86-3.14-7-7-7h-4c-3.86 0-7 3.14-7 7v1c0 .55.45 1 1 1m6-7h4c2.76 0 5 2.24 5 5H5c0-2.76 2.24-5 5-5" />
  </SvgIcon>
);

export const LeftPanelCloseOutlined = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M16.5 14.8V9.2C16.5 8.96667 16.4 8.80833 16.2 8.725C16 8.64167 15.8167 8.68333 15.65 8.85L13.2 11.3C13 11.5 12.9 11.7333 12.9 12C12.9 12.2667 13 12.5 13.2 12.7L15.65 15.15C15.8167 15.3167 16 15.3583 16.2 15.275C16.4 15.1917 16.5 15.0333 16.5 14.8ZM5 21C4.45 21 3.97933 20.8043 3.588 20.413C3.19667 20.0217 3.00067 19.5507 3 19V5C3 4.45 3.196 3.97933 3.588 3.588C3.98 3.19667 4.45067 3.00067 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.0217 20.805 19.5507 21.0007 19 21H5ZM8 19V5H5V19H8ZM10 19H19V5H10V19Z" fill="#424242"/>

  </SvgIcon>
);



export const HourTimeLine = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
	<path fill="currentColor" d="M4.75 2h14.5a.75.75 0 0 1 0 1.5h-.75v2.982a4.75 4.75 0 0 1-2.215 4.017l-2.044 1.29a.25.25 0 0 0 0 .422l2.044 1.29a4.75 4.75 0 0 1 2.215 4.017V20.5h.75a.75.75 0 0 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h.75v-2.982a4.75 4.75 0 0 1 2.215-4.017l2.044-1.29a.25.25 0 0 0 0-.422l-2.044-1.29A4.75 4.75 0 0 1 5.5 6.482V3.5h-.75a.75.75 0 0 1 0-1.5M17 3.5H7v2.982A3.25 3.25 0 0 0 8.516 9.23l2.044 1.29a1.75 1.75 0 0 1 0 2.96l-2.044 1.29A3.25 3.25 0 0 0 7 17.518V20.5h10v-2.982a3.25 3.25 0 0 0-1.516-2.748l-2.044-1.29a1.75 1.75 0 0 1 0-2.96l2.044-1.29A3.25 3.25 0 0 0 17 6.482Z" />
  </SvgIcon>
);

export const ChartPerformance = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M0 0h32v32H0z" fill="none" />
  <path fill="currentColor" d="M28 28V15h-2v13h-4V17h-2v11h-4v-9h-2v9h-4v-7H8v7H4V2H2v26c0 1.1.9 2 2 2h26v-2zm0-24v7h-2V7.42l-8.29 8.29c-.2.19-.45.29-.71.29s-.51-.1-.71-.29L12 11.41l-4.29 4.3l-1.42-1.42l5-5c.39-.39 1.03-.39 1.42 0l4.29 4.3L24.58 6H21V4z" />
  </SvgIcon>
);

export const SuccessIcons = props => (
  <SvgIcon {...props} viewBox="0 0 124 130">
    <rect x="0.5" y="11" width="115" height="111" rx="55.5" fill="#E8F5E9" fill-opacity="0.5"/>
<rect x="10" y="18.5" width="96" height="96" rx="48" fill="#E8F5E9"/>
<path d="M58 26.5C35.92 26.5 18 44.42 18 66.5C18 88.58 35.92 106.5 58 106.5C80.08 106.5 98 88.58 98 66.5C98 44.42 80.08 26.5 58 26.5ZM47.16 83.66L32.8 69.3C31.24 67.74 31.24 65.22 32.8 63.66C34.36 62.1 36.88 62.1 38.44 63.66L50 75.18L77.52 47.66C79.08 46.1 81.6 46.1 83.16 47.66C84.72 49.22 84.72 51.74 83.16 53.3L52.8 83.66C51.28 85.22 48.72 85.22 47.16 83.66Z" fill="#43A047"/>
<path d="M99.5 28.4834C100.96 28.4144 102.201 27.8507 103.22 26.7925C104.24 25.7342 104.75 24.4804 104.75 23.0195C104.75 24.4804 105.26 25.7342 106.28 26.7925C107.3 27.8507 108.54 28.4029 110.012 28.4834C109.05 28.5294 108.17 28.794 107.358 29.3001C106.559 29.7947 105.921 30.4619 105.446 31.2901C104.982 32.1183 104.75 33.004 104.75 33.9702C104.75 32.5094 104.24 31.2441 103.22 30.1858C102.201 29.116 100.96 28.5524 99.5 28.4834ZM115.448 48.3935C116.549 48.3475 117.488 47.9219 118.253 47.1282C119.018 46.3345 119.4 45.3913 119.4 44.287C119.4 45.3913 119.783 46.3345 120.548 47.1282C121.313 47.9219 122.24 48.3475 123.341 48.3935C122.24 48.4395 121.313 48.8651 120.548 49.6588C119.783 50.4525 119.4 51.3957 119.4 52.5C119.4 51.3957 119.018 50.4525 118.253 49.6588C117.522 48.8874 116.514 48.4328 115.448 48.3935Z" fill="#F9A825"/>
<path d="M59.0362 118.277C60.4467 118.211 61.6446 117.666 62.6297 116.644C63.6149 115.622 64.1074 114.411 64.1074 113C64.1074 114.411 64.6 115.622 65.5851 116.644C66.5703 117.666 67.7681 118.2 69.1899 118.277C68.2607 118.322 67.4099 118.577 66.6263 119.066C65.8538 119.544 65.2381 120.188 64.7791 120.988C64.3313 121.788 64.1074 122.644 64.1074 123.577C64.1074 122.166 63.6149 120.944 62.6297 119.922C61.6446 118.888 60.4467 118.344 59.0362 118.277ZM32.457 125.604C33.5205 125.559 34.4273 125.148 35.1662 124.382C35.905 123.615 36.2745 122.704 36.2745 121.637C36.2745 122.704 36.6439 123.615 37.3827 124.382C38.1216 125.148 39.0172 125.559 40.0807 125.604C39.0172 125.648 38.1216 126.059 37.3827 126.826C36.6439 127.593 36.2745 128.504 36.2745 129.57C36.2745 128.504 35.905 127.593 35.1662 126.826C34.4602 126.081 33.4869 125.642 32.457 125.604Z" fill="#E57373"/>
<path d="M0 33.4888C0.938386 33.4459 1.73241 33.088 2.38206 32.4154C3.03171 31.7427 3.36375 30.9412 3.36375 30.0109C3.36375 30.9412 3.68136 31.7427 4.33101 32.4154C4.98067 33.088 5.77469 33.4459 6.71307 33.4888C5.77469 33.5317 4.98067 33.8895 4.33101 34.5622C4.01693 34.8793 3.76964 35.2552 3.60358 35.6681C3.43752 36.0809 3.35599 36.5223 3.36375 36.9667C3.36375 36.0364 3.04615 35.2349 2.38206 34.5622C1.73241 33.8895 0.938386 33.5317 0 33.4888ZM3.36375 16.0278C5.18278 15.9419 6.72751 15.2406 7.99794 13.9239C9.26837 12.6071 9.90359 11.0471 9.90359 9.22943C9.90359 11.0471 10.5388 12.6071 11.8092 13.9239C13.0797 15.2406 14.6244 15.9276 16.4579 16.0278C15.2596 16.085 14.1624 16.4142 13.1518 17.0439C12.1557 17.6594 11.3617 18.4895 10.7698 19.52C10.1923 20.5505 9.90359 21.6525 9.90359 22.8547C9.90359 21.0371 9.26837 19.4627 7.99794 18.146C6.72751 16.815 5.18278 16.1136 3.36375 16.0278ZM1.05437 74.1888C2.42586 74.1316 3.59523 73.602 4.54805 72.6145C5.50087 71.6269 5.97729 70.4533 5.97729 69.0794C5.97729 70.4533 6.4537 71.6269 7.40652 72.6145C8.35935 73.602 9.51428 74.1316 10.8858 74.1888C9.51428 74.2461 8.35935 74.7757 7.40652 75.7632C6.4537 76.7507 5.97729 77.9244 5.97729 79.2983C5.97729 77.9244 5.50087 76.7507 4.54805 75.7632C3.63765 74.8033 2.38245 74.2377 1.05437 74.1888ZM44.6811 5.1238C46.0525 5.06655 47.2075 4.537 48.1603 3.54945C49.1131 2.5619 49.5751 1.38829 49.5751 0C49.5751 1.37398 50.0515 2.54759 51.0043 3.53514C51.9572 4.52269 53.1265 5.05224 54.498 5.10949C53.1265 5.16674 51.9572 5.6963 51.0043 6.68385C50.0515 7.6714 49.5751 8.845 49.5751 10.219C49.5751 8.845 49.0987 7.6714 48.1603 6.68385C47.2075 5.71061 46.0525 5.18105 44.6811 5.1238Z" fill="#66BB6A"/>
  </SvgIcon>
);

export const MobileArrowRightOutlineIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      fill="currentColor"
      d="M7 23q-.825 0-1.412-.587T5 21V3q0-.825.588-1.412T7 1h10q.825 0 1.413.588T19 3v3.1q.45.175.725.55T20 7.5v2q0 .475-.275.85T19 10.9V21q0 .825-.587 1.413T17 23zm0-2h10V3H7zm0 0V3zm1-10v2h4.15l-1.55 1.6L12 16l4-4l-4-4l-1.4 1.4l1.55 1.6z"
    />
  </SvgIcon>
);


export const MessageIcon = props => {
  return (
    <SvgIcon {...props}>
      <path
        fill="none"
        d="M0 0h24v24H0z"
      />

      <path
        d="M22 12L3 20l3.563-8L3 4zM6.5 12H22"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};